import { Component, Inject } from '@angular/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { RegistrationStage, SmsRegistrationService } from '@galaxy/sms';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import {
  ACCOUNT_GROUP_ID_TOKEN,
  CONVERSATION_GOOGLE_BUSINESS_MESSAGES_AVAILABLE_TOKEN,
  CONVERSATION_SMS_ENABLED_TOKEN,
} from '../../../core/src/lib/tokens';
import { InboxService } from '../../../core/src/lib/inbox.service';
@Component({
  selector: 'inbox-alert-banner',
  standalone: true,
  imports: [GalaxyAlertModule, TranslateModule, AsyncPipe, NgIf],
  templateUrl: './inbox-alert-banner.component.html',
})
export class InboxAlertBannerComponent {
  readonly registrationStatus$ = this.smsRegistrationService.registrationStage$;
  readonly registrationFormRoute$ = this.accountGroupId$.pipe(
    map((id) => `/account/location/${id}/settings/inbox/sms-registration`),
  );

  private readonly hideInboxAlertBanner$$ = new BehaviorSubject<boolean>(false);
  readonly hideInboxAlertBanner$ = this.hideInboxAlertBanner$$.asObservable();

  readonly showGrandfatheringBanner$ = combineLatest([
    this.smsEnabled$,
    this.googleBusinessMessagesAvailable$,
    this.hideInboxAlertBanner$,
    this.inboxService.SMSNumber$,
  ]).pipe(
    map(([smsEnabled, googleBusinessMessagesAvailable, hideInboxAlertBanner, smsNumber]) => {
      return !smsEnabled && !googleBusinessMessagesAvailable && !hideInboxAlertBanner && !!smsNumber;
    }),
  );

  protected readonly RegistrationStage = RegistrationStage;

  constructor(
    private readonly smsRegistrationService: SmsRegistrationService,
    @Inject(ACCOUNT_GROUP_ID_TOKEN) private readonly accountGroupId$: Observable<string>,
    @Inject(CONVERSATION_SMS_ENABLED_TOKEN) private smsEnabled$: Observable<boolean>,
    @Inject(CONVERSATION_GOOGLE_BUSINESS_MESSAGES_AVAILABLE_TOKEN)
    private googleBusinessMessagesAvailable$: Observable<boolean>,
    private readonly inboxService: InboxService,
  ) {}

  onBannerClosed(): void {
    this.hideInboxAlertBanner$$.next(true);
  }
}
